import { User } from '@/utils/Interfaces'
import { RootState } from './index'
import { Module } from 'vuex'
import { getLoginUser, updateUserInfo } from '@/utils/ApiServices'


declare interface UserState {
  currentUser: User;
  updatingUser: boolean;
}

export const user: Module<UserState, RootState> = {
  state: {
    currentUser: new User,
    updatingUser: false,
  },

  getters: {
    isSuperUser (state) {
      return state.currentUser.is_superuser
    },

    isAuthenticated (state) {
      return state.currentUser.id !== ''
    },
  },

  mutations: {
    SET_CURRENT_USER (state, user: User) {
      state.currentUser = user
    },

    SET_UPDATING_USER (state, isUpdating: boolean) {
      state.updatingUser = isUpdating
    },
  },

  actions: {
    setCurrentUser (context) {
      return getLoginUser()
        .then(response => {
          const user = new User(response.data)
          context.commit('SET_CURRENT_USER', user)
          return response
        })
    },

    updateUserInfo (context, user: User) {
      context.commit('SET_UPDATING_USER', true)
      return updateUserInfo(user)
        .then(response => {
          const user = new User(response.data)
          context.commit('SET_CURRENT_USER', user)
          return response
        })
        .finally(() => {
          context.commit('SET_UPDATING_USER', false)
        })
    },

    clearUserInfo (context) {
      context.commit('SET_CURRENT_USER', new User)
    },
  }
}
